// Extended
import BaseUIAssistantGroupListView from 'xui/modules/store/storeSetting/BaseUIAssistantGroupListView'

export default class AssistantGroupListView extends BaseUIAssistantGroupListView {
  static displayName = 'AssistantGroupListView'
}
